var _path, _path2, _path3, _circle, _path4, _path5, _path6, _circle2, _circle3, _circle4, _path7, _path8, _polygon, _circle5, _path9, _path10, _polygon2, _polygon3, _path11, _polygon4, _path12, _path13, _polygon5, _path14, _path15, _circle6, _path16, _path17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUndrawOrderConfirmed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 816.215 621",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M326.608 128.781h-2.977v-81.57A47.21 47.21 0 0 0 276.42 0H103.601a47.21 47.21 0 0 0-47.21 47.21v447.502a47.21 47.21 0 0 0 47.21 47.21H276.42a47.21 47.21 0 0 0 47.21-47.21V186.844h2.978Z",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M278.325 12.283h-22.558a16.75 16.75 0 0 1-15.509 23.076h-99.005a16.75 16.75 0 0 1-15.508-23.076h-21.07a35.256 35.256 0 0 0-35.257 35.256v446.845a35.256 35.256 0 0 0 35.257 35.256h173.65a35.256 35.256 0 0 0 35.256-35.256V47.539a35.256 35.256 0 0 0-35.256-35.256Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M382 542H1a1 1 0 0 1 0-2h381a1 1 0 0 1 0 2Z",
    fill: "#cbcbcb"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 44",
    cx: 191.5,
    cy: 261.234,
    r: 84.446,
    fill: "#1a629b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 395",
    d: "M183.132 293.447a8.758 8.758 0 0 1-5.27-1.75l-.093-.071-19.846-15.182a8.82 8.82 0 1 1 10.731-13.998l12.855 9.857 30.376-39.629a8.816 8.816 0 0 1 12.36-1.633l.003.002-.189.262.194-.262a8.826 8.826 0 0 1 1.63 12.363l-35.728 46.592a8.821 8.821 0 0 1-7.015 3.439Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M694.245 550.3a26.263 26.263 0 0 1 3.606-4.595 28.581 28.581 0 0 1 1.774-1.674 28.142 28.142 0 0 1 46.402 16.007c4.124-15.252-6.612-30.276-17.406-41.815-10.8-11.536-23.143-24.192-23.081-39.999.03-8.796 4.333-16.642 10.829-22.46.2-.176.4-.352.605-.522a41.071 41.071 0 0 1 28.288-9.859c19.2 1.029 35.963 13.932 47.605 29.238 18.739 24.627 26.95 59.197 13.831 87.231-11.539 24.657-36.148 39.298-61.265 51.07q-5.26 2.465-10.5 4.782c-.023.006-.048.023-.072.03-.168.073-.336.147-.494.223l-2.157.95.331.217 1.033.668c-.358-.216-.712-.427-1.07-.644-.107-.065-.22-.127-.325-.193-12.336-7.402-24.844-15.232-33.366-26.788-8.838-11.997-12.392-29.183-4.568-41.867Z",
    fill: "#f1f1f1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M776.548 522.436a69.818 69.818 0 0 1 5.375 19.53 60.624 60.624 0 0 1-.73 18.013 77.675 77.675 0 0 1-15.578 33.322 111.792 111.792 0 0 1-20.182 19.62q-5.26 2.466-10.5 4.783c-.023.006-.049.023-.072.03-.168.073-.336.147-.494.223l-2.156.95.33.217 1.033.668c-.358-.216-.712-.427-1.07-.644-.106-.065-.22-.127-.325-.193a61.796 61.796 0 0 0-11.208-55.646 62.325 62.325 0 0 0-23.12-17.604 28.547 28.547 0 0 1 1.774-1.674 64.62 64.62 0 0 1 9.903 5.655 63.317 63.317 0 0 1 23.959 31.74 64.735 64.735 0 0 1 1.405 36.188c.619-.405 1.24-.82 1.845-1.233 11.492-7.75 22.083-17.058 30.06-28.471a72.261 72.261 0 0 0 12.822-32.585c1.53-12.834-1.682-25.454-7.412-36.905a151.257 151.257 0 0 0-23.696-33.67 171.872 171.872 0 0 0-31.776-27.322 1.236 1.236 0 0 1-.366-1.664 1.051 1.051 0 0 1 .605-.522.915.915 0 0 1 .78.158c1.44.96 2.868 1.93 4.279 2.929a173.822 173.822 0 0 1 31.765 29.016c9.03 10.555 17.25 22.281 22.75 35.091Z",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 44",
    cx: 525.042,
    cy: 21.276,
    r: 17.934,
    fill: "#f1f1f1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 44",
    cx: 748.042,
    cy: 268.276,
    r: 10.934,
    fill: "#f1f1f1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 44",
    cx: 428.042,
    cy: 298.276,
    r: 10.934,
    fill: "#f1f1f1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M434.215 621h381a1 1 0 1 0 0-2h-381a1 1 0 0 0 0 2Z",
    fill: "#cbcbcb"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M773.17 96.635a14.652 14.652 0 0 0-28.137-7.426l-30.917 35.444 9.072 25.337 31.093-41.415a14.573 14.573 0 0 0 18.889-11.94Z",
    fill: "#ffb7b7"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "645.013 234.549 747.642 125.02 733.799 103.012 605.076 211.876 645.013 234.549",
    fill: "#3f3d56"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 622.108,
    cy: 132,
    r: 36,
    fill: "#2f2e41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M625.001 111.663a75.485 75.485 0 0 1 27.464-17.759c6.638-2.46 13.864-3.979 20.805-2.582 6.94 1.396 13.504 6.198 15.44 13.008 1.583 5.568-.052 11.563-2.509 16.805-2.457 5.242-5.737 10.103-7.724 15.54a35.468 35.468 0 0 0 35.689 47.562c-6.82.915-13.106 4.12-19.771 5.825-6.666 1.706-14.533 1.59-19.486-3.185-5.241-5.053-5.346-13.267-5.093-20.543l1.13-32.445c.192-5.515.356-11.207-1.633-16.355-1.989-5.148-6.716-9.656-12.234-9.609-4.183.036-7.885 2.57-11.239 5.068-3.354 2.499-6.904 5.165-11.07 5.536-4.167.372-8.924-2.711-8.612-6.882Z",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M485.377 373.723a14.652 14.652 0 0 1-11.039-26.925l31.1-35.284 26.305 5.683-36.997 36.239a14.573 14.573 0 0 1-9.369 20.287Z",
    fill: "#ffb7b7"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "587.698 247.405 510.183 344.705 486.555 333.857 577.665 192.012 587.698 247.405",
    fill: "#3f3d56"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "525.848 541.211 507.374 540.921 509.596 603.887 525.845 603.887 525.848 541.211",
    fill: "#ffb7b7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m529.99 598.582-32.001-.001h-.001a20.395 20.395 0 0 0-20.394 20.393v.663l52.395.002Z",
    fill: "#2f2e41"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "648.165 524.511 627.984 537.467 668.352 586.032 682.026 577.253 648.165 524.511",
    fill: "#ffb7b7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m682.647 570.55-26.929 17.288a20.395 20.395 0 0 0-6.143 28.18l.358.557 44.09-28.307Z",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M655.355 332.24s-44.84-148.927-59.25-150.94-37.628 38.213-37.628 38.213c-30.103 38.408-61.144 162.821-61.144 162.821s51.746 3.238 89.573 23.364 82.468-1.02 82.468-1.02Z",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M847.247 471.74s-44.84-148.927-59.25-150.94-31.73 38.621-31.73 38.621c-15 62-67.042 162.413-67.042 162.413s51.747 3.238 89.573 23.364 82.468-1.02 82.468-1.02Z",
    transform: "translate(-191.892 -139.5)",
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "618.567 287.682 618.567 362.517 627.374 470.921 671.374 552.921 650.374 567.921 590.374 489.921 566.643 412.472 529.374 583.921 501.374 581.921 520.82 344.21 557.721 277.3 618.567 287.682",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M573.358 215.3c-14 14-1 29-1 29l-16 36 63 17 22.016-98.379-15-16c-30-1-30.016-1.621-30.016-1.621-5.257 5.144-23 34-23 34Z",
    fill: "#1a629b"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M643.91 188.73a26.884 26.884 0 0 0-37.776 5.913c-15.838 22.052-30.483 57.66-10.305 102.071 32.399 71.31 60.593 107.815 72.055 107.81a4.56 4.56 0 0 0 1.473-.23c7.055-2.394 17.256-14.333 19.103-24.853.66-3.766.504-9.01-4-12.612-12.935-10.347-36.158-42.562-43.402-84.964-4.003-23.43 3.76-44.772 10.978-58.55a26.88 26.88 0 0 0-7.777-34.33Z",
    fill: "#3f3d56"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 803.14,
    cy: 280.711,
    r: 26.5,
    transform: "rotate(-28.663 434.183 586.507)",
    fill: "#ffb7b7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M573.98 139.207h38.265l.393-5.494 1.962 5.494h5.892l.777-10.888 3.889 10.888h11.4v-.54a28.624 28.624 0 0 0-28.591-28.592h-5.395a28.624 28.624 0 0 0-28.592 28.593Z",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m630.778 158.954 16.33-5.298V114h-30.845l.764.762c10.625 10.611 22.441 48.257 13.75 44.192Z",
    fill: "#2f2e41"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawOrderConfirmed);
export default __webpack_public_path__ + "static/media/undraw_order_confirmed.bb0f8ccec650c78a03c7f12f5836f23a.svg";
export { ForwardRef as ReactComponent };